/* Tenue. — cadeau automatique : 6 paires de chaussettes dès 5 débardeurs dans le panier.
   - Ajoute 1 lot quand le panier contient au moins N débardeurs (tous coloris et tailles confondus)
   - Ramène la quantité du cadeau à 1 si le client l'augmente
   - Retire le cadeau si le panier repasse sous N débardeurs
   La gratuité est appliquée par la réduction Shopify « Achetez 5, chaussettes offertes » :
   ce script ne fait que mettre l'article dans le panier. */
import { CartUpdateEvent, ThemeEvents } from '@theme/events';

const SOURCE = 'tenue-gift';
const configEl = document.getElementById('tenue-gift-config');
const config = configEl ? JSON.parse(configEl.textContent) : null;
let busy = false;

function cartItemsSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId || el.getAttribute('data-section-id'))
    .filter(Boolean);
}

async function postJson(url, body) {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(`${url} ${response.status}`);
  return response.json();
}

async function reconcile() {
  if (!config || !config.giftVariantId || !config.tankProductId || busy) return;
  busy = true;
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const tanks = cart.items
      .filter((item) => item.product_id === config.tankProductId)
      .reduce((sum, item) => sum + item.quantity, 0);
    const giftLines = cart.items.filter((item) => item.variant_id === config.giftVariantId);
    const giftQty = giftLines.reduce((sum, item) => sum + item.quantity, 0);
    const sectionIds = cartItemsSectionIds();
    const sections = sectionIds.length ? sectionIds.join(',') : undefined;

    let result = null;
    if (tanks >= config.minQty && giftQty === 0) {
      result = await postJson('/cart/add.js', { items: [{ id: config.giftVariantId, quantity: 1 }], sections });
    } else if (tanks >= config.minQty && giftQty > 1) {
      result = await postJson('/cart/change.js', { id: giftLines[0].key, quantity: 1, sections });
    } else if (tanks < config.minQty && giftQty > 0) {
      result = await postJson('/cart/change.js', { id: giftLines[0].key, quantity: 0, sections });
    }
    if (!result) return;

    /* Page panier classique : on recharge simplement */
    if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
      window.location.reload();
      return;
    }
    /* Tiroir panier : on prévient le thème, qui redessine le tiroir et la pastille */
    const updatedCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    document.dispatchEvent(
      new CartUpdateEvent(updatedCart, SOURCE, {
        source: SOURCE,
        itemCount: updatedCart.item_count,
        sections: result.sections || undefined,
      })
    );
  } catch (error) {
    console.warn('[tenue-gift]', error);
  } finally {
    busy = false;
  }
}

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  if (event.detail && event.detail.data && event.detail.data.source === SOURCE) return;
  reconcile();
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
else reconcile();
